import { Component, ViewChild } from '@angular/core';
import { Message } from '../shared/model/message';
import { MessageType } from '../shared/model/message-type';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { GameComponent } from '../game/game.component';
import { GameStatus } from '../shared/model/game-status';
import { SECOND } from '../shared/consts/conts';
import { TimerComponent } from '../timer/timer.component';

@Component({
  selector: 'pbg-trivia',
  templateUrl: './trivia.component.html',
  styleUrls: ['./trivia.component.scss']
})
export class TriviaComponent extends GameComponent {
  @ViewChild('timer')
  timer: TimerComponent;
  questionText = '';
  questionChoices: string[] = [];
  maxTime = SECOND * 20;
  expiration: number;
  startTime = 0;
  disableButtons = false;
  countDownText = this.maxTime;
  showTimer = false;
  currentAnswer;
  points = 0;

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute
  ) {
    super(socketService, cookieService, router, resolver);
  }

  messageHandler(message: Message) {
    if (
      message.action === MessageType.Question ||
      (message.action === MessageType.Host &&
        message.content.status === GameStatus.InProgress)
    ) {
      this.disableButtons = false;
      this.waitMode = false;
      this.questionText = message.content.currentQuestion.question;
      this.questionChoices = message.content.currentQuestion.choices;
      this.expiration = message.content.questionExpiration;
      this.startTimer();
    }
  }

  clean() {
    this.clearTimer();
  }

  startTimer() {
    this.showTimer = true;
  }

  submissionHandler(message: string) {
    this.currentAnswer = message;
    this.points = this.timer.getTimeLeft();
    this.disableButtons = true;
    this.waitMode = true;
    this.clearTimer();
    this.sendAnswer();
  }

  sendAnswer(): void {
    const score = {
      answer: this.currentAnswer,
      points: this.points
    };

    console.log(score);

    this.socketService.send({
      from: this.user,
      content: score,
      action: MessageType.Response,
      gameId: this.gameId
    });
  }

  clearTimer() {
    this.showTimer = false;
  }

  timerHandler(timerStatus: any) {
    if (timerStatus.status.ended) {
      this.disableButtons = true;
      this.sendAnswer();
    }
  }
}
